import { LoadSpinner } from '@calizahq/react-components-v2'
import { Property } from '@sales-app/api/GeoLocation/GeoLocation'
import { PropertyHomes } from '@sales-app/api/PropertyHomes/PropertyHomes'
import { transformToPropertyAPIQuery } from '@sales-app/context/workspace/homeFilters.util'
import { WorkspaceTab } from '@sales-app/context/workspace/workspace.type'
import React, { useMemo } from 'react'

import { useAPI } from '@/hooks'

import { HomeList } from './HomeList'
import { PopupContents, PopupFigure } from './MapPopup.styles'
import { transformHomes } from './MapPopup.util'
import { MapPopupAmenitiesList } from './MapPopupAmenitiesList'

export interface PopupContentProps {
  bookablePerson: WorkspaceTab
  property: Property
}

export function PopupContent({ property, bookablePerson }: PopupContentProps): JSX.Element {
  const filters = bookablePerson?.potentialBookingFilters || { listView: true }
  const { data, isLoading } = useAPI<PropertyHomes.GET.Response>(PropertyHomes.getPropertyHomes(property.slug), {
    params: transformToPropertyAPIQuery({ ...filters }),
    enabled: !!property.slug,
  })

  const formattedHomes = useMemo(() => {
    return data && data.data.homes ? transformHomes(data.data.homes, bookablePerson) : []
  }, [data, bookablePerson])

  return (
    <PopupContents data-testid="map-popup-content-wrapper">
      <PopupFigure>
        <figcaption className="py-4">
          <h3 className="px-3 font-medium text-xl leading-120">{property.name}</h3>
          <h3 className="mb-1 mt-1 px-3 text-base leading-140 text-grey-600">{property.street}</h3>
          {!isLoading ? (
            <>
              <HomeList filters={filters} homes={formattedHomes} propertyId={property.id} />
            </>
          ) : (
            <LoadSpinner />
          )}

          <MapPopupAmenitiesList property={property} />
        </figcaption>
      </PopupFigure>
    </PopupContents>
  )
}
